import classNames from 'classnames'
import type { FC } from 'react'
import React from 'react'

import { useCardContext } from './card-context'
import type { CardContentProps } from './types'
import { BoxPrivate } from '../_primitives/box/box'

export const CardContent: FC<CardContentProps> = React.forwardRef<
  HTMLDivElement,
  CardContentProps
>(function CardContent(props, ref) {
  const { variant = 'content', className, children, ...rest } = props
  const { variant: cardVariant } = useCardContext()
  return (
    <BoxPrivate
      ref={ref}
      __themeKey="cards"
      variant={cardVariant ? `${cardVariant}.content` : variant}
      className={classNames(
        {
          'csg-tui-card-content': true
        },
        className
      )}
      {...rest}
    >
      {children}
    </BoxPrivate>
  )
})

export default CardContent
